import React from 'react';

import './index.scss';

const PSModalPdf = ({ show, onClose, pdfUrl }) => {
  if (!show) return null;

  return (
    <div className="pdf-modal-backdrop" onClick={onClose}>
      <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
        <iframe src={pdfUrl} width="100%" height="700px" title="PDF Viewer" frameBorder="0" />
      </div>
    </div>
  );
};

export default PSModalPdf;
